
export const front = {
	el: '#main-vue',
	mixins: [],

	ready() {
		console.log('corre front')
		
	},
};



// WEBPACK FOOTER //
// ./resources/assets/js/vue/main/front.js